import SignupForm from "../SignupForm";

const Signup = () => {

    return (
        <SignupForm
            url="/account/sign-up"
        />
    );
};

export default Signup;